import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import moment from "moment";
import { stringify, stringifyParams } from "../../../../utils/stringify";
import { API_DATE_FORMAT } from "../../../../app_constants";
import { api } from "../api";

export const FETCH_TABLE_CHART_SUCCESS = "sagas/attendance/activeClients/FETCH_TABLE_CHART_SUCCESS";
export const FETCH_LINE_CHART_SUCCESS = "sagas/attendance/activeClients/FETCH_LINE_CHART_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "sagas/attendance/activeClients/FETCH_FILTERS_SUCCESS";
export const FETCH_CURRENT_USER = "sagas/attendance/activeClients/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS =
  "sagas/attendance/activeClients/FETCH_CURRENT_USER_SUCCESS";

export const RESET_FILTER_SELECTED = "sagas/attendance/activeClients/RESET_FILTER_SELECTED";
const RESET_FILTER = "sagas/attendance/activeClients/RESET_FILTER";

export const SET_CROSS_REGIONAL_VISITS = "sagas/attendance/activeClients/SET_CROSS_REGIONAL_VISITS";
export const SET_UPDATES_LOADING = "sagas/attendance/activeClients/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "sagas/attendance/activeClients/SET_FILTERS_DIRTY";
export const SET_CUSTOM_DATES = "sagas/attendance/activeClients/SET_CUSTOM_DATES";
export const SET_LOADING = "sagas/attendance/activeClients/SET_LOADING";
export const SET_DATES = "sagas/attendance/activeClients/SET_DATES";

const UPDATE_CROSS_REGIONAL_VISITS = "sagas/attendance/activeClients/UPDATE_CROSS_REGIONAL_VISITS";
export const UPDATE_PERIOD_TYPE = "sagas/attendance/activeClients/UPDATE_PERIOD_TYPE";
export const UPDATE_CHART = "sagas/attendance/activeClients/UPDATE_CHART";
export const UPDATE_CROSS_REGIONAL_VISITS_SELECTED =
  "sagas/attendance/activeClients/UPDATE_CROSS_REGIONAL_VISITS_SELECTED";

export const UPDATE_CUSTOM_RANGE = "sagas/attendance/activeClients/UPDATE_CUSTOM_RANGE";
export const UPDATE_DATES = "sagas/attendance/activeClients/UPDATE_DATES";
export const UPDATE_COMPARE_DATES_SELECTED =
  "sagas/attendance/activeClients/UPDATE_COMPARE_DATES_SELECTED";
export const UPDATE_PROSPECT_TYPE = "sagas/attendance/activeClients/UPDATE_PROSPECT_TYPE";
export const UPDATE_MEMBERSHIP_TYPE = "sagas/attendance/activeClients/UPDATE_MEMBERSHIP_TYPE";
export const UPDATE_FILTER_BY = "sagas/attendance/activeClients/UPDATE_FILTER_BY";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateCrossRegionalVisits: createAction(UPDATE_CROSS_REGIONAL_VISITS),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateDates: createAction(UPDATE_DATES),
  updateData: createAction(UPDATE_CHART),
  resetFilters: createAction(RESET_FILTER),
  updateProspectType: createAction(UPDATE_PROSPECT_TYPE),
  updateMembershipType: createAction(UPDATE_MEMBERSHIP_TYPE),
  updateFilterBy: createAction(UPDATE_FILTER_BY)
};

export default function* watchActiveVisits() {
  yield takeLatest(UPDATE_CROSS_REGIONAL_VISITS, updateCrossRegionalVisits);
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
  yield takeLatest(RESET_FILTER, resetFilters);
  yield takeLatest(UPDATE_CHART, updateData);
}

function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield setDates();
  try {
    yield getActiveClientsFilters();
    yield fetchChart();
    yield fetchChart("table");
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* setDates() {
  const endDate = yield select((state) => state.activeClients.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format(API_DATE_FORMAT);

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* getApiParams() {
  let { startDate: start_date, endDate: end_date } = yield select(
    (state) => state.activeClients.selectedRequestDates
  );
  let { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  return { organization_id, short_url, start_date, end_date };
}

function* fetchChart(chartType) {
  const commonParams = yield getApiParams();

  const { period_type, prospect_types, membership_types, filter_by, ...rest } = yield select(
    (state) => state.activeClients.selectedFilters
  );

  const isMembershipMode = filter_by === "Membership Types";

  const params = {
    ...commonParams,
    table_view: chartType === "table",
    period_type: period_type.toLowerCase(),
    ...(isMembershipMode
      ? { membership_type_ids: stringify(membership_types) }
      : { prospect_type_ids: stringify(prospect_types) }),
    ...stringifyParams(rest)
  };

  yield getActiveClientsChart(params);
}

function* getActiveClientsFilters() {
  try {
    const { organization_id, short_url } = yield getApiParams();
    const response = yield call(api.getFilters, { organization_id, short_url });

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data.filters });
    yield setDates();
    yield setCrossRegionalVisits();
  } catch (err) {
    console.error(err);
  }
}

function* setCrossRegionalVisits() {
  let source = yield select((state) => state.commonReducer.commonProps.sourceType);
  let payload = yield select(
    (state) => state.activeClients.filters.toggles.crossRegionalVisits.default
  );

  if (source === "clubready") {
    yield put({
      type: SET_CROSS_REGIONAL_VISITS,
      payload
    });
  }
}
function* getActiveClientsChart(params) {
  try {
    const response = yield call(api.getChart, params);

    if (params.table_view) {
      yield put({ type: FETCH_TABLE_CHART_SUCCESS, payload: response.data.data });
    } else {
      yield put({ type: FETCH_LINE_CHART_SUCCESS, payload: response.data.data });
    }
  } catch (err) {
    console.error(err);
  }
}

function* updateCrossRegionalVisits({ payload }) {
  yield put({ type: UPDATE_CROSS_REGIONAL_VISITS_SELECTED, payload });
}

function* updateCustomRange() {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}

function* updateData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  try {
    yield fetchChart();
    yield fetchChart("table");
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  yield setDates();

  yield put({ type: RESET_FILTER_SELECTED });
  yield setCrossRegionalVisits();

  try {
    yield fetchChart();
    yield fetchChart("table");
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
